export enum BadgeStatusType {
  Success = 'success',
  Warning = 'warning',
  Error = 'error',
  Neutral = 'neutral',
  Info = 'info',
  Warning2 = 'warning2',
}

export const getStatusStyles = (status: BadgeStatusType, version?: 'v1' | 'v2') => {
  if (version) {
    if (version === 'v1') {
      switch (status) {
        case BadgeStatusType.Success:
          return 'bg-green-700 text-white';
        case BadgeStatusType.Warning:
        case BadgeStatusType.Warning2:
          return 'bg-yellow text-[#967F0C]';
        case BadgeStatusType.Neutral:
          return 'bg-gray-600 text-white';
        case BadgeStatusType.Info:
          return 'bg-blue-600 text-white';
        case BadgeStatusType.Error:
          return 'bg-red-600 text-white';
        default:
          return 'bg-gray-600 text-white';
      }
    } else {
      switch (status) {
        case BadgeStatusType.Success:
          return 'bg-green-200 text-green-700';
        case BadgeStatusType.Warning:
          return 'bg-orange text-white';
        case BadgeStatusType.Error:
          return 'text-red-800 bg-red-200';
        case BadgeStatusType.Neutral:
          return 'bg-primary-50 text-[#A4B2C0]';
        case BadgeStatusType.Info:
          return 'bg-[#CCE0FF] text-blue';
        case BadgeStatusType.Warning2:
          return 'bg-[#FFE878] text-[#BCA010]';
        default:
          return 'bg-gray-400';
      }
    }
  } else {
    return 'bg-gray-400';
  }
};

export const getStatusText = (status: BadgeStatusType) => {
  switch (status) {
    case BadgeStatusType.Success:
      return 'OK';
    case BadgeStatusType.Warning:
      return 'Ostrzeżenie';
    case BadgeStatusType.Error:
      return 'Występują';
    case BadgeStatusType.Neutral:
      return 'Inne';
    case BadgeStatusType.Info:
      return 'Brak';
    default:
      return 'Status';
  }
};
